import { PriceType } from '@cfixe-monorepo/shared';
import type { BookingAmounts, BookingLabels, CartSummary } from '../types';

/**
 * Valeur totale affichable du panier — logique partagée entre le récap
 * (TunnelSummary) et le StepFooter. Tous les montants arrivent déjà
 * formatés serveur.
 *
 * - Panier 100 % « aucun prix » → libellé « à déterminer » (pas de « 0,00 € »)
 * - Récap `amounts` (pré-réservation, sinon résumé du panier) → total après remise, avant bons
 * - Summary pas encore chargé → '…' pendant le chargement, '' sinon
 * - Résumé du panier en échec (`failed`, bug 11) → '' : jamais un total périmé affiché comme à jour
 */
export function computeSummaryTotalValue(
  cartSummary: CartSummary | undefined,
  cartSummaryLoading: boolean,
  labels: Pick<BookingLabels, 'timeline_price_to_determine_on_site'>,
  amounts?: BookingAmounts,
  failed = false,
): string {
  if (failed) return '';
  const allNoPrice =
    !!cartSummary &&
    cartSummary.items.length > 0 &&
    cartSummary.items.every((item): boolean => item.price_type === PriceType.NONE);

  if (allNoPrice) return labels.timeline_price_to_determine_on_site;
  if (amounts) return amounts.net_total;
  if (cartSummary) return cartSummary.total_price;
  return cartSummaryLoading ? '…' : '';
}

/** Total au prix normal, barré devant le total quand une remise le fait baisser (rien si le résumé est en échec). */
export function computeSummaryStruckTotal(amounts: BookingAmounts | undefined, failed = false): string | undefined {
  return !failed && amounts && amounts.net_total_raw < amounts.gross_total_raw ? amounts.gross_total : undefined;
}
